import CheckboxNext from './checkbox-next';

export default CheckboxNext;
